export default "__VITE_ASSET__BQ71HCjd__"